/* unplugin-vue-components disabled */import { render } from "./StandardNotificationDialog.vue?vue&type=template&id=1f53d130&scoped=true&ts=true"
import script from "./StandardNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./StandardNotificationDialog.vue?vue&type=script&lang=ts"

import "./StandardNotificationDialog.vue?vue&type=style&index=0&id=1f53d130&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f53d130"]])

export default __exports__